import { useEffect } from "react";
import serviceProvider from '../../services/axios'
import { useHistory } from "react-router-dom";
import { decrypter} from  '../../webutils/webutils'


export default function Weblive(props){
    const history = useHistory();   

    


useEffect(async ()=>{
   const { match } = props;
   const { params } = match;
   if(!!params && 'id' in  params){
       const encodedEmail = params.id;
       const email = decrypter(encodedEmail)
       
    if(email){
        try{
          
            if(email){
				 window.open(`https://apishowcasen.smarterchains.com/masterplanner/masterplanner/plant/${email}`,"_self");
            }
        }catch(error){
            history.push('sign-in');
        }
    }else{
        history.push('sign-in');
    }
   
   }


},[])

return (<div />)

}